import {
    normalizePicture,
    PublicPictureFromApi,
    PublicWebsiteContentPictureFromApi,
} from '../../../../core/Api/PublicWebsite/Resources/picture';
import { defaultPicture } from '../../../../domains/Picture/Picture';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import {
    SearchSuggestion,
    SearchSuggestionsResult,
    SearchSuggestionsResultType,
    SearchSuggestionType,
} from '../../domain/types/searchSuggestions';

export type SearchSuggestionFromPWAPI = {
    id: number;
    type: SearchSuggestionType;
    name: string;
    slug: string;
    destination_id: number;
    parent_destination_slug: string | null;
    parent_name: string | null;
    child_region_count: number | null;
    agency_count: number | null;
    cover_picture: PublicPictureFromApi | PublicWebsiteContentPictureFromApi | null;
};

export type SearchSuggestionsResponseFromPWAPI = {
    type: SearchSuggestionsResultType;
    results: Array<SearchSuggestionFromPWAPI>;
};

type NormalizedSearchSuggestionFromPWAPI = PickDomain<
    SearchSuggestion,
    'id' | 'type' | 'name' | 'slug' | 'destinationId' | 'coverPicture',
    {
        parentDestinationSlug: SearchSuggestion['parentDestinationSlug'] | null;
        parentName: SearchSuggestion['parentName'] | null;
        childRegionCount: SearchSuggestion['childRegionCount'] | null;
        agencyCount: SearchSuggestion['agencyCount'] | null;
    }
>;

export type NormalizedSearchSuggestionsResultFromPWAPI = PickDomain<
    SearchSuggestionsResult,
    'type',
    {
        suggestions: Array<NormalizedSearchSuggestionFromPWAPI>;
    }
>;

export function normalizeSearchSuggestionsResponseFromPWAPI(
    response: SearchSuggestionsResponseFromPWAPI,
): NormalizedSearchSuggestionsResultFromPWAPI {
    return {
        type: response.type,
        suggestions: response.results.map(normalizeSearchSuggestionFromPWAPI),
    };
}

function normalizeSearchSuggestionFromPWAPI(
    suggestion: SearchSuggestionFromPWAPI,
): NormalizedSearchSuggestionFromPWAPI {
    return {
        id: suggestion.id,
        type: suggestion.type,
        name: suggestion.name,
        slug: suggestion.slug,
        destinationId: suggestion.destination_id,
        parentDestinationSlug: suggestion.parent_destination_slug,
        parentName: suggestion.parent_name,
        childRegionCount: suggestion.child_region_count,
        agencyCount: suggestion.agency_count,
        coverPicture: suggestion.cover_picture
            ? normalizePicture(suggestion.cover_picture)
            : defaultPicture(),
    };
}
